module.exports = __webpack_public_path__ + "static/media/HSP40_final_sequences.7eee3853.fa";